import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

const dictionaries = {
  es: {
    "app.name": "GameCraft 2D",
    "app.tagline": "Crea videojuegos 2D desde cualquier lugar",
    "nav.dashboard": "Proyectos",
    "nav.logout": "Cerrar sesión",
    "auth.login": "Entrar con Google",
    "auth.checking": "Verificando sesión...",
    "auth.required": "Inicia sesión para continuar",
    "landing.hero.title": "Crea videojuegos 2D desde cualquier lugar, en todo momento.",
    "landing.hero.sub": "Estudio en la nube: ideas, historia, sprites, audio, código, canvas+kanban y motor de pruebas, con IA.",
    "landing.cta": "Empieza ahora",
    "landing.features.title": "Todo lo que necesita un game dev",
    "landing.f1.title": "Planificación y GDD",
    "landing.f1.body": "Historia, objetivos, secretos, personajes, enemigos, jefes, armas, vehículos y artefactos.",
    "landing.f2.title": "Editor de código",
    "landing.f2.body": "Estructura de carpetas, archivos y lenguaje a tu gusto. Listo para pegar a tu motor.",
    "landing.f3.title": "Pixel art + IA",
    "landing.f3.body": "Canvas profesional, capas mentales, paleta. Genera sprites con Nano Banana.",
    "landing.f4.title": "Simulador de pruebas",
    "landing.f4.body": "Visualiza FPS, daño, vida, hotkeys, colisiones y métricas en vivo.",
    "landing.f5.title": "Controles visuales",
    "landing.f5.body": "Mapea teclado, ratón y mando (Xbox, PlayStation, Switch) con vista visual.",
    "landing.f6.title": "Biblioteca y motores",
    "landing.f6.body": "Vincula tu base de datos personal. Exporta a tu motor favorito.",
    "dashboard.title": "Mis proyectos",
    "dashboard.new": "Nuevo proyecto",
    "dashboard.empty": "Aún no tienes proyectos. Crea el primero.",
    "dashboard.open": "Abrir",
    "dashboard.delete": "Eliminar",
    "modal.new.title": "Crear nuevo proyecto",
    "modal.new.name": "Nombre del juego",
    "modal.new.desc": "Descripción corta",
    "modal.new.genre": "Género",
    "modal.new.mode": "Modo",
    "modal.new.engine": "Motor objetivo",
    "modal.new.create": "Crear",
    "modal.new.cancel": "Cancelar",
    "ide.tabs.gdd": "Planificación",
    "ide.tabs.project": "Proyecto",
    "ide.tabs.ideas": "Ideas",
    "ide.tabs.canvas": "Canvas & Kanban",
    "ide.tabs.engine": "Motor de Pruebas",
    "ide.tabs.code": "Código",
    "ide.tabs.sprites": "Sprites & Arte",
    "ide.tabs.simulator": "Simulador",
    "ide.tabs.controls": "Controles",
    "ide.tabs.assets": "Assets",
    "ide.tabs.ai": "IA",
    "ide.tabs.settings": "Ajustes",
    "ide.tabs.map": "Mapa",
    "ide.tabs.story": "Historia",
    "ide.tabs.audio": "Audio",
    "ide.tabs.animation": "Animación",
    "ide.tabs.export": "Exportar",
    "ide.tabs.palette": "Paletas",
    "ide.tabs.overview": "Resumen",
    "ide.section.planning": "Planificación",
    "ide.section.create": "Creación",
    "ide.section.play": "Pruebas",
    "ide.section.production": "Producción",
    "cmdk.placeholder": "Buscar pestañas, entidades, sprites...",
    "cmdk.tabs": "Pestañas",
    "cmdk.entities": "Entidades",
    "cmdk.sprites": "Sprites",
    "cmdk.files": "Archivos",
    "cmdk.actions": "Acciones",
    "cmdk.empty": "Sin resultados",
    "overview.welcome": "Vista general",
    "overview.welcomeSub": "Todo tu proyecto en una pantalla. Haz click en cualquier tarjeta para abrir su módulo.",
    "overview.openModule": "Abrir",
    "overview.empty": "Vacío. Empieza añadiendo elementos.",
    "overview.recentSprites": "Sprites recientes",
    "overview.idea": "Idea principal",
    "overview.story": "Historia",
    "overview.objective": "Objetivo",
    "overview.totalEntities": "Entidades",
    "overview.codeFiles": "Archivos de código",
    "overview.soundtracks": "Soundtracks",
    "overview.animations": "Animaciones",
    "overview.mapPreview": "Mapa de entidades",
    "overview.storyPreview": "Flujo de historia",
    "overview.share": "Compartir proyecto",
    "overview.shareSub": "Genera una URL pública y deja que otros remixen tu juego.",
    "common.search": "Buscar",
    "palette.title": "Cambio de paleta",
    "palette.selectSource": "Sprite base",
    "palette.basePalette": "Paleta original",
    "palette.newPalette": "Nueva paleta",
    "palette.preview": "Vista previa",
    "palette.save": "Guardar variante",
    "palette.reset": "Restablecer",
    "palette.variants": "Variantes",
    "palette.presets": "Presets",
    "palette.empty": "Selecciona un sprite del proyecto para empezar",
    "palette.variantName": "Nombre de la variante",
    "ide.save": "Guardar",
    "ide.saved": "Guardado",
    "ide.saving": "Guardando...",
    "ide.share": "Compartir",
    "ide.share.public": "Público",
    "ide.share.private": "Privado",
    "ide.share.copy": "Copiar enlace",
    "ide.share.copied": "¡Enlace copiado!",
    "ide.share.title": "Showcase público",
    "ide.share.desc": "Activa para obtener una URL pública compartible y permitir remix.",
    "ide.share.url": "URL pública",
    "ide.share.thumbnail": "Capturar miniatura (desde simulador)",
    "ide.share.viewPublic": "Ver página pública",
    "map.title": "Mapa de entidades",
    "map.legend": "Arrastra los nodos, conecta entidades dibujando entre puntos",
    "map.regenerate": "Generar desde GDD",
    "map.clear": "Limpiar",
    "map.add": "Añadir nodo",
    "story.title": "Flujo de la historia",
    "story.add": "Añadir escena",
    "story.scene": "Escena",
    "showcase.remix": "Remixar este juego",
    "showcase.by": "por",
    "showcase.remixes": "remixes",
    "showcase.remixOf": "remix de",
    "showcase.signin": "Inicia sesión para remixar",
    "showcase.cta": "Crea tu propio juego",
    "toast.projectCreated": "Proyecto creado",
    "toast.projectDeleted": "Proyecto eliminado",
    "toast.deleteFailed": "Error al eliminar",
    "toast.saveFailed": "Error al guardar",
    "toast.aiFailed": "Falló la IA",
    "toast.notFound": "No encontrado",
    "toast.linkCopied": "Enlace copiado",
    "toast.thumbCaptured": "Miniatura capturada",
    "toast.published": "Proyecto publicado",
    "toast.unpublished": "Proyecto despublicado",
    "gdd.idea": "Idea principal",
    "gdd.objective": "Objetivo del juego",
    "gdd.story": "Historia",
    "gdd.goals": "Metas",
    "gdd.secrets": "Secretos",
    "gdd.notes": "Notas",
    "gdd.add": "Añadir",
    "entities.characters": "Personajes",
    "entities.enemies": "Enemigos",
    "entities.bosses": "Jefes",
    "entities.items": "Objetos",
    "entities.weapons": "Armas",
    "entities.tools": "Herramientas",
    "entities.artifacts": "Artefactos",
    "entities.vehicles": "Vehículos",
    "entities.name": "Nombre",
    "entities.role": "Rol / Tipo",
    "entities.stats": "Estadísticas",
    "entities.notes": "Descripción",
    "code.newfile": "Nuevo archivo",
    "code.delete": "Eliminar archivo",
    "sprite.tools.brush": "Pincel",
    "sprite.tools.eraser": "Borrador",
    "sprite.tools.bucket": "Cubo",
    "sprite.tools.picker": "Selector",
    "sprite.size": "Tamaño",
    "sprite.clear": "Limpiar",
    "sprite.export": "Exportar PNG",
    "sprite.save": "Guardar en proyecto",
    "sprite.ai.generate": "Generar con IA",
    "sprite.ai.placeholder": "Describe el sprite (ej: caballero pixelart 32x32)",
    "sim.run": "Ejecutar",
    "sim.pause": "Pausar",
    "sim.reset": "Reiniciar",
    "sim.fps": "FPS",
    "sim.hp": "Vida",
    "sim.dmg": "Daño",
    "sim.keys": "Teclas",
    "controls.keyboard": "Teclado y Ratón",
    "controls.gamepad": "Mando",
    "controls.type": "Tipo de mando",
    "assets.empty": "Sin sprites guardados",
    "assets.title": "Biblioteca de sprites",
    "ai.title": "Asistente IA",
    "ai.placeholder": "Describe qué necesitas (ej: 3 ideas de jefes para nivel volcán)",
    "ai.send": "Generar",
    "settings.db": "Base de datos personal",
    "settings.db.uri": "URI MongoDB / Postgres",
    "settings.db.test": "Probar conexión",
    "settings.lang": "Idioma",
    "common.cancel": "Cancelar",
    "common.confirm": "Confirmar",
    "common.delete": "Eliminar",
    "common.add": "Añadir",
    "common.close": "Cerrar",
  },
  en: {
    "app.name": "GameCraft 2D",
    "app.tagline": "Build 2D games from anywhere",
    "nav.dashboard": "Projects",
    "nav.logout": "Sign out",
    "auth.login": "Sign in with Google",
    "auth.checking": "Checking session...",
    "auth.required": "Sign in to continue",
    "landing.hero.title": "Build 2D games from anywhere, anytime.",
    "landing.hero.sub": "Cloud studio: ideas, story, sprites, audio, code, canvas+kanban and a test engine, with AI.",
    "landing.cta": "Get started",
    "landing.features.title": "Everything a game dev needs",
    "landing.f1.title": "Planning & GDD",
    "landing.f1.body": "Story, goals, secrets, characters, enemies, bosses, weapons, vehicles and artifacts.",
    "landing.f2.title": "Code editor",
    "landing.f2.body": "Folder structure, files and language of your choice. Ready to paste into your engine.",
    "landing.f3.title": "Pixel art + AI",
    "landing.f3.body": "Pro canvas, palette and tools. Generate sprites with Nano Banana.",
    "landing.f4.title": "Test simulator",
    "landing.f4.body": "Live FPS, damage, HP, hotkeys, collisions and metrics.",
    "landing.f5.title": "Visual controls",
    "landing.f5.body": "Map keyboard, mouse and gamepad (Xbox, PlayStation, Switch) visually.",
    "landing.f6.title": "Library & engines",
    "landing.f6.body": "Link your own database. Export to your favorite engine.",
    "dashboard.title": "My projects",
    "dashboard.new": "New project",
    "dashboard.empty": "You don't have any projects yet. Create your first one.",
    "dashboard.open": "Open",
    "dashboard.delete": "Delete",
    "modal.new.title": "Create new project",
    "modal.new.name": "Game name",
    "modal.new.desc": "Short description",
    "modal.new.genre": "Genre",
    "modal.new.mode": "Mode",
    "modal.new.engine": "Target engine",
    "modal.new.create": "Create",
    "modal.new.cancel": "Cancel",
    "ide.tabs.gdd": "Planning",
    "ide.tabs.project": "Project",
    "ide.tabs.ideas": "Ideas",
    "ide.tabs.canvas": "Canvas & Kanban",
    "ide.tabs.engine": "Test Engine",
    "ide.tabs.code": "Code",
    "ide.tabs.sprites": "Sprites & Art",
    "ide.tabs.simulator": "Simulator",
    "ide.tabs.controls": "Controls",
    "ide.tabs.assets": "Assets",
    "ide.tabs.ai": "AI",
    "ide.tabs.settings": "Settings",
    "ide.tabs.map": "Map",
    "ide.tabs.story": "Story",
    "ide.tabs.audio": "Audio",
    "ide.tabs.animation": "Animation",
    "ide.tabs.export": "Export",
    "ide.tabs.palette": "Palettes",
    "ide.tabs.overview": "Overview",
    "ide.section.planning": "Planning",
    "ide.section.create": "Create",
    "ide.section.play": "Playtest",
    "ide.section.production": "Production",
    "cmdk.placeholder": "Search tabs, entities, sprites...",
    "cmdk.tabs": "Tabs",
    "cmdk.entities": "Entities",
    "cmdk.sprites": "Sprites",
    "cmdk.files": "Files",
    "cmdk.actions": "Actions",
    "cmdk.empty": "No results",
    "overview.welcome": "Overview",
    "overview.welcomeSub": "Your whole project on one screen. Click any card to open its module.",
    "overview.openModule": "Open",
    "overview.empty": "Empty. Start adding items.",
    "overview.recentSprites": "Recent sprites",
    "overview.idea": "Core idea",
    "overview.story": "Story",
    "overview.objective": "Objective",
    "overview.totalEntities": "Entities",
    "overview.codeFiles": "Code files",
    "overview.soundtracks": "Soundtracks",
    "overview.animations": "Animations",
    "overview.mapPreview": "Entity map",
    "overview.storyPreview": "Story flow",
    "overview.share": "Share project",
    "overview.shareSub": "Generate a public URL and let others remix your game.",
    "common.search": "Search",
    "palette.title": "Palette swap",
    "palette.selectSource": "Base sprite",
    "palette.basePalette": "Original palette",
    "palette.newPalette": "New palette",
    "palette.preview": "Preview",
    "palette.save": "Save variant",
    "palette.reset": "Reset",
    "palette.variants": "Variants",
    "palette.presets": "Presets",
    "palette.empty": "Select a project sprite to start",
    "palette.variantName": "Variant name",
    "ide.save": "Save",
    "ide.saved": "Saved",
    "ide.saving": "Saving...",
    "ide.share": "Share",
    "ide.share.public": "Public",
    "ide.share.private": "Private",
    "ide.share.copy": "Copy link",
    "ide.share.copied": "Link copied!",
    "ide.share.title": "Public showcase",
    "ide.share.desc": "Enable to get a shareable public URL and let others remix.",
    "ide.share.url": "Public URL",
    "ide.share.thumbnail": "Capture thumbnail (from simulator)",
    "ide.share.viewPublic": "View public page",
    "map.title": "Entity map",
    "map.legend": "Drag nodes, connect entities by drawing between handles",
    "map.regenerate": "Generate from GDD",
    "map.clear": "Clear",
    "map.add": "Add node",
    "story.title": "Story flow",
    "story.add": "Add scene",
    "story.scene": "Scene",
    "showcase.remix": "Remix this game",
    "showcase.by": "by",
    "showcase.remixes": "remixes",
    "showcase.remixOf": "remix of",
    "showcase.signin": "Sign in to remix",
    "showcase.cta": "Create your own game",
    "toast.projectCreated": "Project created",
    "toast.projectDeleted": "Project deleted",
    "toast.deleteFailed": "Delete failed",
    "toast.saveFailed": "Save failed",
    "toast.aiFailed": "AI failed",
    "toast.notFound": "Not found",
    "toast.linkCopied": "Link copied",
    "toast.thumbCaptured": "Thumbnail captured",
    "toast.published": "Project published",
    "toast.unpublished": "Project unpublished",
    "gdd.idea": "Core idea",
    "gdd.objective": "Game objective",
    "gdd.story": "Story",
    "gdd.goals": "Goals",
    "gdd.secrets": "Secrets",
    "gdd.notes": "Notes",
    "gdd.add": "Add",
    "entities.characters": "Characters",
    "entities.enemies": "Enemies",
    "entities.bosses": "Bosses",
    "entities.items": "Items",
    "entities.weapons": "Weapons",
    "entities.tools": "Tools",
    "entities.artifacts": "Artifacts",
    "entities.vehicles": "Vehicles",
    "entities.name": "Name",
    "entities.role": "Role / Type",
    "entities.stats": "Stats",
    "entities.notes": "Description",
    "code.newfile": "New file",
    "code.delete": "Delete file",
    "sprite.tools.brush": "Brush",
    "sprite.tools.eraser": "Eraser",
    "sprite.tools.bucket": "Bucket",
    "sprite.tools.picker": "Picker",
    "sprite.size": "Size",
    "sprite.clear": "Clear",
    "sprite.export": "Export PNG",
    "sprite.save": "Save to project",
    "sprite.ai.generate": "Generate with AI",
    "sprite.ai.placeholder": "Describe the sprite (e.g.: pixel art knight 32x32)",
    "sim.run": "Run",
    "sim.pause": "Pause",
    "sim.reset": "Reset",
    "sim.fps": "FPS",
    "sim.hp": "HP",
    "sim.dmg": "Damage",
    "sim.keys": "Keys",
    "controls.keyboard": "Keyboard & Mouse",
    "controls.gamepad": "Gamepad",
    "controls.type": "Controller type",
    "assets.empty": "No saved sprites",
    "assets.title": "Sprite library",
    "ai.title": "AI Assistant",
    "ai.placeholder": "Describe what you need (e.g.: 3 boss ideas for volcano level)",
    "ai.send": "Generate",
    "settings.db": "Personal database",
    "settings.db.uri": "MongoDB / Postgres URI",
    "settings.db.test": "Test connection",
    "settings.lang": "Language",
    "common.cancel": "Cancel",
    "common.confirm": "Confirm",
    "common.delete": "Delete",
    "common.add": "Add",
    "common.close": "Close",
  },
};

const I18nContext = createContext({ lang: "es", t: (k) => k, setLang: () => {} });

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("gf_lang") || "es");
  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("gf_lang", l);
  }, []);
  const t = useCallback(
    (key) => dictionaries[lang]?.[key] || dictionaries.es[key] || key,
    [lang]
  );
  const value = useMemo(() => ({ lang, t, setLang }), [lang, t, setLang]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
